import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { DeviceContext } from "../context/DeviceContext";
import { toast, Toaster } from "react-hot-toast";

import ToastDisplay from "../components/ToastDisplay";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

const DeviceSetup = () => {
	const navigate = useNavigate();
	const [deviceSession, setDeviceSession] = useContext(DeviceContext);
	const [key, setKey] = useState("");
	const [actionLoading, setActionLoading] = useState(false);

	const setupDevice = async (e) => {
		e.preventDefault();

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				key: key,
			}),
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/devices/setup`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content={data.msg} />);
			setKey("");
		} else {
			setDeviceSession(data.device_key);
		}
		setActionLoading(false);
	};

	useEffect(() => {
		if (deviceSession) {
			navigate("/scanner");
		}
	}, [deviceSession]);

	return (
		<>
			<Toaster
				position="bottom-right"
				toastOptions={{ className: "snackbar-container" }}
			/>
			<div className="full-page flex-column">
				<Container className="flex-column">
					<div className="col-lg-6 col-md-7 col-12">
						<h1 className="title-md text-medium-gotham">Device Setup</h1>
						<p>Please enter the device key.</p>
						<Form className="full" onSubmit={setupDevice}>
							<Row className="mb-30">
								<Col>
									<div className="device-setup-input border rounded-4 bg-white flex-row-left">
										<Form.Control
											autofocus
											className="text-sm"
											placeholder="Device key"
											value={key}
											onChange={(e) => setKey(e.target.value)}
										/>
										<Button
											type="submit"
											className="device-setup-btn rounded-4 flex-column"
											disabled={!key}
										>
											{actionLoading ? (
												<Spinner className="btn-loader text-white" />
											) : (
												<i className="ri-arrow-right-long-fill text-white" />
											)}
										</Button>
									</div>
								</Col>
							</Row>
						</Form>
					</div>
				</Container>
			</div>
		</>
	);
};

export default DeviceSetup;
